import { CMSSection } from '@/cms/CMSSection';
import { Container } from '@/components/Container';
import { HitsPagination } from '@/components/HitsPagination';
import { ListingHits } from '@/components/ListingHits';
import type { ContentfulPlaceholderFragment } from '@/graphql/contentful/api';
import type { PlaceholderType } from '@/integrations/contentful';
import { generateDataTestId } from '@/lib/tests';

export type PlaceholderProductListingOpts = {
  isMostRelevantCta?: boolean;
  productType?: string;
  type: PlaceholderType;
};

type PlaceholderProductListingProps = ContentfulPlaceholderFragment &
  PlaceholderProductListingOpts;

export const PlaceholderProductListing = (
  _props: PlaceholderProductListingProps,
) => (
  <CMSSection {...generateDataTestId('section', 'productListing')}>
    <Container>
      <ListingHits
        isMostRelevantCta={_props.isMostRelevantCta}
        productType={
          _props.productType ||
          (_props.type === 'product listing' ? 'eyewear' : undefined)
        }
      />
      <HitsPagination padding={3} />
    </Container>
  </CMSSection>
);
